import { Ferret } from "non-ui/data";

export const REPLACE_FERRETS : string = 'ferrets:replace-ferrets';

export interface FerretAction {
  type: typeof REPLACE_FERRETS;
  payload: Ferret[];
}